import { SET_BORROWER_COLLECTIONS, SET_INVESTOR_COLLECTIONS, SET_SYSTEM_SETTINGS } from './action';

const investorCollectionReducer = (state = { investorCollections: {} }, action) => {
	switch (action.type) {
		case SET_INVESTOR_COLLECTIONS: {
			return { ...state, investorCollections: action.payload };
		}
		default:
			return state;
	}
};

const borrowerCollectionReducer = (state = { borrowerCollections: {} }, action) => {
	switch (action.type) {
		case SET_BORROWER_COLLECTIONS: {
			return { ...state, borrowerCollections: action.payload };
		}
		default:
			return state;
	}
};

const systemSettingsDataReducer = (state = { settings: {} }, action) => {
	switch (action.type) {
		case SET_SYSTEM_SETTINGS: {
			return { ...state, settings: action.payload };
		}
		default:
			return state;
	}
};

export { investorCollectionReducer, borrowerCollectionReducer, systemSettingsDataReducer };
